import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';

import { useModal } from '../../../../function/useModal';
import { ErrorCode } from '../../../../ErrorCode';

import PartialDischargeGrid from './PartialDischargeGrid';
import {
    GetPartialDischargeStatusData,
    V_PARTIAL_DISCHARGE_STATUS_ITEM,
    GetManCollectionStat,
    CheckManualTime,
    PutPartialDischargeStatusData,
    ChangeMancollectionStat
} from './../PartialDischarge';
import { TableBaseStyle } from './../PartialDischargeStyle';

type PartialDischargeProps = {};


const PartialDischargePage: React.FC<PartialDischargeProps> = (props: PartialDischargeProps) => {
    const tableStyle = TableBaseStyle();
    const { t } = useTranslation();
    const [itemList, setItemList] = useState<V_PARTIAL_DISCHARGE_STATUS_ITEM[]>([]);

    const [okCancelDialogOpen, setOkCancelDialogOpen] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState<string>('');
    const [selectDevIndex, setSelectDevIndex] = React.useState<number>(0);
    const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
    const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
    const [dlgmsg, setDlgmsg] = useState<string>('');

    const cfmdlg = flgCfmDlg ? (
        <ConfirmDialog
            dialog={actCfmDlg}
            message={dlgmsg}
            action={t('PartialDischargeCollectionPage.はい', 'はい')}
            cancel={t('PartialDischargeCollectionPage.いいえ', 'いいえ')}
        />
    ) : null;

    const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
    /**
   * 初期表示
   */
    useEffect(() => {
        console.debug(['useEffect init', props]);
        updateData();

        const interval = setInterval(() => {
            updateData();
        }, 10000);




        return () => {
            clearInterval(interval);
        };


    }, []);

    /**
     * 画面更新
     */
    const updateData = () => {
        let partialDischargeStatusItems: V_PARTIAL_DISCHARGE_STATUS_ITEM[] = [];

        //データの取得
        GetPartialDischargeStatusData()
            .then((res) => {
                console.debug(['--PartialDischargeStatusModel--', res]);

                if (res.ResponceData.ErrorCode !== ErrorCode.ERR_CODE_DATA_NONCATCH) {
                    partialDischargeStatusItems = res.PartialDischargeStatusItems;
                    partialDischargeStatusItems.forEach((row) => {
                        row.manualButtonStat = GetManCollectionStat(partialDischargeStatusItems, row);
                        console.debug([`row.manualButtonStat, ${row.manualButtonStat}`, row, row.manualButtonStat]);
                    })
                }
                else {
                    setDlgmsg(t('PartialDischargeCollectionPage.DEV_INDEXがnullまたは該当するPLC_NOが存在しません', 'DEV_INDEXがnullまたは該当するPLC_NOが存在しません'));
                    actMsgDlg.open();
                }
                setItemList(partialDischargeStatusItems);
            }).catch(e => {
                setDlgmsg(t('PartialDischargeCollectionPage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
                actMsgDlg.open();
                console.debug(["e", e]);
                //setButtonEnable(false);
            }).finally(() => {
                //setButtonEnable(true);
                console.debug(["update end"]);
            });
    }

    /**
     * 行設定変更通知
     * @param target 
     */
    const changePartialDischargeType = (target: V_PARTIAL_DISCHARGE_STATUS_ITEM) => {
        console.debug(['changePartialDischargeType - start', itemList, target]);
        setItemList(
            itemList.map((r) => (r.SET_NO === target.SET_NO) ? target : r)
        )
        GetManCollectionStat(itemList, target);
        PutPartialDischargeStatusData(target);

        setItemList(
            ChangeMancollectionStat(itemList, target)
        );

        console.debug(['changePartialDischargeType - end', itemList, target]);
    };

    return (
        <>
            <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 0 }}>
                <Grid item xs={12}>
                    <PartialDischargeGrid
                        partialDischargeTypeList={itemList}
                        onChangeRowData={changePartialDischargeType}

                    />
                </Grid>
            </Grid>
            {cfmdlg}
            {msgdlg}
        </>

    )

}
export default PartialDischargePage;